module.exports = __webpack_public_path__ + "img/landing-main.b85ee135.jpg";